var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoDataIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    color: "#CCCCF4",
    viewBox: "0 0 57 56",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#noData)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m28.5 56c15.464 0 28-12.536 28-28s-12.536-28-28-28-28 12.536-28 28 12.536 28 28 28z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.117 28.02c0 10.151 8.2298 18.381 18.381 18.381 10.152 0 18.382-8.2298 18.382-18.381h-36.763z",
    fill: "#0000C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.278 35.297c0 5.6446 4.5764 10.221 10.221 10.221 5.6452 0 10.221-4.5765 10.221-10.221h-20.442z",
    fill: "#CA2027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.989 22.74c2.4287 0 4.3975-1.9688 4.3975-4.3974 0-2.4287-1.9688-4.3975-4.3975-4.3975-2.4286 0-4.3974 1.9688-4.3974 4.3975 0 2.4286 1.9688 4.3974 4.3974 4.3974z",
    fill: "#0000C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.617 22.74c2.4287 0 4.3975-1.9688 4.3975-4.3974 0-2.4287-1.9688-4.3975-4.3975-4.3975-2.4286 0-4.3974 1.9688-4.3974 4.3975 0 2.4286 1.9688 4.3974 4.3974 4.3974z",
    fill: "#0000C8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "noData"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "translate(.5)",
    width: 56,
    height: 56,
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataIcon);
export default __webpack_public_path__ + "static/media/noDataIcon.10971aaac34d4d69d0d6523f01c613b4.svg";
export { ForwardRef as ReactComponent };